import { render, staticRenderFns } from "./addNewDealer.vue?vue&type=template&id=5eafd436"
import script from "./addNewDealer.vue?vue&type=script&lang=js"
export * from "./addNewDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports